export const IN_EUROPE = 'IN_EUROPE';
export const OUT_OF_EUROPE = 'OUT_OF_EUROPE';
